const FAQ = () => {
    return (
        <div>
            <h2>Frequently Asked Questions (FAQ)</h2>
            <h3>1. Who is ISW?</h3>
            <p>ISW stands for Internet Software Works, a company dedicated to providing cutting-edge software solutions.</p>
            <h3>2. How can I contact ISW?</h3>
            <p>You can contact us through the Contact page
                on our website or email us at tome@internetsoftwareworks.com</p>
            <h3>3. What services does ISW provide?</h3>
            <p>SW specializes in custom full-stack software development, mobile app development,
                backend API design, cloud architecture, and consulting on hosting and deployment solutions.
                We help turn your ideas into production-ready applications.</p>
            <h3>4. What technologies does ISW work with?</h3>
            <p>We work with modern technologies including Java, Spring Boot, Node.js, TypeScript,
                React, React Native, AWS, and a wide range of web and cloud platforms.</p>
            <h3>5. Who does ISW typically work with?</h3>
            <p>SW partners with startups, small businesses, and established
                companies looking to build new software, modernize existing
                systems, or improve application performance and reliability.</p>
            <h3>How does the development process work?</h3>    
            <p>We follow a collaborative, iterative process that starts with understanding your goals. 
                From there, we design, build, test, and deploy your solution using 
                industry best practices and agile methodology.</p>
                <h3>7. Do you offer project-based or hourly consulting?</h3>
                <p>Yes. ISW offers flexible engagement models including fixed-scope projects, 
                    ongoing support, and hourly consulting—whichever best fits your needs.</p>
                    <h3>8. Can ISW help update or fix an existing application?</h3>
                    <p>Absolutely. We can review your existing system, identify issues, 
                        make performance improvements, modernize outdated code, or assist with new feature development.</p>
                        <h3>9. Do you build mobile apps?</h3>
                        <p>Yes. We have experience building mobile applications using React 
                            Native and integrating them with scalable backend APIs.</p>
                            <h3>10. Do you work with cloud platforms?</h3>
                            <p>Yes. ISW provides cloud consulting and development on AWS, 
                                including serverless solutions such as AWS Lambda.</p>
                             <h3>11. What is your typical turnaround time?</h3>   
                             <p>This depends on project size, but most engagements begin with a 
                                discovery call where we outline a timeline and milestones 
                                so you know what to expect.</p>
                                <h3>12. Do you offer ongoing maintenance or support?</h3>
                                <p>Yes. ISW can provide continued support, bug fixes, enhancements, 
                                    and long-term maintenance for your application.</p>

        </div>
    );
};
export default FAQ;
